import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import RegistrationContext from "../contexts/RegistrationContext";
import { base_url } from "../config";
import countriesData from "../countries.json";
import WhiteBoxLayout from "../components/WhiteBoxLayout/WhiteBoxLayout";
import "./style.css";
import { useRef } from "react";

function PersonalData() {
  const {
    setError,
    reload,
    setReload,
    data,

    clickedNext,
    setClickedNext,
  } = useContext(RegistrationContext);
  const [firstName, setFirstname] = useState(data.first_name);
  const [familyName, setFamilyName] = useState(data.family_name);
  const [Affiliation, setAffiliation] = useState(data.affiliation);
  const [Affiliation2, setAffiliation2] = useState(data.affiliation2);
  const [nameBadge, setNameBadge] = useState(data.name_badge);
  const [affiliationBadge, setAffiliationBadge] = useState(data.affiliation_badge);
  const [address1, setAddress1] = useState(data.address1);
  const [address2, setAddress2] = useState(data.address2);
  const [postcode, setPostcode] = useState(data.postcode);
  const [city, setCity] = useState(data.city);
  const [province, setProvince] = useState(data.province);
  const [country, setCountry] = useState(data.country);
  const [tax_id, setTaxId] = useState(data.tax_id);
  const [billing_address1, setBillingAddress1] = useState(data.billing_address1);
  const [billing_address2, setBillingAddress2] = useState(data.billing_address2);
  const [billing_postcode, setBillingPostcode] = useState(data.billing_postcode);
  const [billing_city, setBillingCity] = useState(data.billing_city);
  const [billing_province, setBillingProvince] = useState(data.billing_province);
  const [billing_country, setBillingCountry] = useState(data.billing_country);
  const [billing_tax_id, setBillingTaxId] = useState(data.billing_tax_id);


  const [sameAsAddress, setSameAsAddress] = useState(data.same_as_address);

  const [sponsorsCheck, setSponsorsCheck] = useState(data.share_data_sponsor);
  const [workshopCheck, setWorkshopCheck] = useState(data.share_data_workshop);
  const [deleteProfileCheck, setDeleteProfileCheck] = useState(
    data.delete_profile
  );

  const formRef = useRef();
  const submitBotton = useRef();
  const [errors, setErrors] = useState({}); // State to track errors

  const validateForm = () => {
    const newErrors = {};

    if (!firstName || !firstName.trim()) {
      newErrors.firstName = "First Name is required.";
    }
    if (!familyName || !familyName.trim()) {
      newErrors.familyName = "Family Name is required.";
    }
    if (!Affiliation || !Affiliation.trim()) {
      newErrors.Affiliation = "Affiliation Line 1 is required.";
    }
    if (!nameBadge || !nameBadge.trim()) {
      newErrors.nameBadge = "Name in the badge is required.";
    }
    if (!affiliationBadge || !affiliationBadge.trim()) {
      newErrors.affiliationBadge = "Affiliation in the badge is required.";
    }
    if (!address1 || !address1.trim()) {
      newErrors.address1 = "Address Line 1 is required.";
    }
    if (!postcode || !postcode.trim()) {
      newErrors.postcode = "Postcode/ZIP code is required.";
    }
    if (!city || !city.trim()) {
      newErrors.city = "City is required.";
    }
    if (!country || !country.trim()) {
      newErrors.country = "Country is required.";
    }
    if (!sameAsAddress) {
      if (!billing_address1 || !billing_address1.trim()) {
        newErrors.billing_address1 = "Address Line 1 is required.";
      }
      if (!billing_postcode || !billing_postcode.trim()) {
        newErrors.billing_postcode = "Postcode/ZIP code is required.";
      }
      if (!billing_city || !billing_city.trim()) {
        newErrors.billing_city = "City is required.";
      }
      if (!billing_country || !billing_country.trim()) {
        newErrors.billing_country = "Country is required.";
      }
    }

    if (!workshopCheck) {
      newErrors.workshopCheck = "You must select an option for sharing data with workshop organizers.";
    }
    if (!sponsorsCheck) {
      newErrors.sponsorsCheck = "You must select an option for sharing data with sponsors.";
    }
    if (!deleteProfileCheck) {
      newErrors.deleteProfileCheck = "You must select an option for deleting your profile.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleSelect = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    try {
      setClickedNext(0);
      await axios.post(`${base_url}/api/progress`, {
        first_name: firstName,
        family_name: familyName,
        affiliation: Affiliation,
        affiliation2: Affiliation2,
        name_badge: nameBadge,
        affiliation_badge: affiliationBadge,
        address1: address1,
        address2: address2,
        postcode: postcode,
        city: city,
        province: province,
        country: country,
        tax_id: tax_id,
        same_as_address: sameAsAddress,
        billing_address1: billing_address1,
        billing_address2: billing_address2,
        billing_postcode: billing_postcode,
        billing_city: billing_city,
        billing_province: billing_province,
        billing_country: billing_country,
        billing_tax_id: billing_tax_id,
        share_data_sponsor: sponsorsCheck,
        share_data_workshop: workshopCheck,
        delete_profile: deleteProfileCheck,
      });
      setReload(reload + 1);
    } catch (error) {
      setError("Unexpected error. " + error.response.data.message);
    }
  };

  useEffect(() => {
    if (clickedNext === 0) return;
    submitBotton.current.click();
  }, [clickedNext]);


  return (
    <>
      <WhiteBoxLayout title={"Personal data"} handleSelect={handleSelect}>

        <div className="w-full max-w-6xl mx-auto bg-white p-4 rounded-lg ">
          <h1 className="text-xl font-bold ">Personal Data</h1>
          {data.prefilled_from_previous_year && (
            <div className="my-3 rounded-md border-l-4 border-blue-500 bg-blue-50 px-3 py-2 text-sm text-blue-800">
              We pre-filled this form with the profile you submitted for
              IJCAI-25. Please review the fields and update anything that has
              changed before continuing.
            </div>
          )}
          <form
            ref={formRef}
            method="POST"
            className="space-y-4 md:space-y-6"
            onSubmit={handleSelect}
          >
            <div className="md:flex md:flex-col md:gap-2">
              <button type="submit" ref={submitBotton} className="hidden">
                hidden
              </button>
              <div className="w-full my-4">
                <div className="py-2">
                  <label
                    htmlFor="first_name"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    First Name: <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    value={firstName}
                    onChange={(e) => setFirstname(e.target.value)}
                    className={`bg-gray-50 border ${errors.firstName ? "border-red-500" : "border-gray-300"
                      } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                    placeholder="your first name"
                    required
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>
                  )}
                </div>
                <div className="py-2">
                  <label
                    htmlFor="family_name"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Family Name: <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    id="family_name"
                    name="family_name"
                    value={familyName}
                    onChange={(e) => setFamilyName(e.target.value)}
                    className={`bg-gray-50 border ${errors.familyName ? "border-red-500" : "border-gray-300"
                      } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                    placeholder="your family name"
                    required
                  />
                  {errors.familyName && (
                    <p className="text-red-500 text-sm mt-1">{errors.familyName}</p>
                  )}
                </div>
                <div className="py-2">
                  <label
                    htmlFor="Affiliation"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Affiliation Line 1: <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    id="Affiliation"
                    name="Affiliation"
                    placeholder="your affiliation"
                    value={Affiliation}
                    onChange={(e) => setAffiliation(e.target.value)}
                    className={`bg-gray-50 border ${errors.Affiliation ? "border-red-500" : "border-gray-300"
                      } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                    required
                  />
                  {errors.Affiliation && (
                    <p className="text-red-500 text-sm mt-1">{errors.Affiliation}</p>
                  )}
                </div>
                <div className="py-2">
                  <label
                    htmlFor="Affiliation2"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Affiliation Line 2:
                  </label>
                  <input
                    type="text"
                    id="Affiliation2"
                    name="Affiliation2"
                    placeholder="your affiliation"
                    value={Affiliation2}
                    onChange={(e) => setAffiliation2(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                  />
                </div>
                <div className="py-2">
                  <label
                    htmlFor="name_badge"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Name in the badge: <span className="text-red-600">*</span>
                  </label>
                  <div>
                    <input
                      type="text"
                      id="name_badge"
                      name="name_badge"
                      placeholder="your name in the badge"
                      value={nameBadge}
                      onChange={(e) => setNameBadge(e.target.value)}
                      className={`bg-gray-50 border ${errors.nameBadge ? "border-red-500" : "border-gray-300"
                        } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                      required
                    />
                    <span className="help-block text-xs">
                      Enter your name EXACTLY the way you want it to appear on
                      the badge!
                    </span>
                    {errors.nameBadge && (
                      <p className="text-red-500 text-sm mt-1">{errors.nameBadge}</p>
                    )}
                  </div>
                </div>
                <div className="py-2">
                  <label
                    htmlFor="affiliation_badge"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Affiliation in the badge:{" "}
                    <span className="text-red-600">*</span>
                  </label>
                  <div>
                    <input
                      type="text"
                      id="affiliation_badge"
                      name="affiliation_badge"
                      placeholder="your affiliation in the badge"
                      value={affiliationBadge}
                      onChange={(e) => setAffiliationBadge(e.target.value)}
                      className={`bg-gray-50 border ${errors.affiliationBadge ? "border-red-500" : "border-gray-300"
                        } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                      required
                    />
                    <span className="help-block text-xs">
                      Enter your affiliation EXACTLY the way you want it to
                      appear on the badge!
                    </span>
                    {errors.nameBadge && (
                      <p className="text-red-500 text-sm mt-1">{errors.affiliationBadge}</p>
                    )}
                  </div>
                </div>
              </div>
              <h1 className="text-xl font-bold ">Address</h1>
              <div className="w-full ">
                <div className="py-2">
                  <label
                    htmlFor="address1"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Address Line 1: <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    id="address1"
                    name="address1"
                    value={address1}
                    onChange={(e) => setAddress1(e.target.value)}
                    className={`bg-gray-50 border ${errors.address1 ? "border-red-500" : "border-gray-300"
                      } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                    placeholder="address Line 1"
                    required
                  />
                  {errors.address1 && (
                    <p className="text-red-500 text-sm mt-1">{errors.address1}</p>
                  )}
                </div>
                <div className="py-2">
                  <label
                    htmlFor="address2"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Address Line 2:
                  </label>
                  <input
                    type="text"
                    id="address2"
                    name="address2"
                    value={address2}
                    onChange={(e) => setAddress2(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                    placeholder="address2"
                  />
                </div>
                <div className="py-2">
                  <label
                    htmlFor="postcode"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Postcode/ZIP code: <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    id="postcode"
                    name="postcode"
                    value={postcode}
                    onChange={(e) => setPostcode(e.target.value)}
                    className={`bg-gray-50 border ${errors.postcode ? "border-red-500" : "border-gray-300"
                      } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                    placeholder="your postcode/zip code"
                    required
                  />
                  {errors.postcode && (
                    <p className="text-red-500 text-sm mt-1">{errors.postcode}</p>
                  )}
                </div>
                <div className="py-2">
                  <label
                    htmlFor="city"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    City: <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    className={`bg-gray-50 border ${errors.city ? "border-red-500" : "border-gray-300"
                      } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                    placeholder="your city"
                    required
                  />
                  {errors.city && (
                    <p className="text-red-500 text-sm mt-1">{errors.city}</p>
                  )}
                </div>
                <div className="py-2">
                  <label
                    htmlFor="province"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Province/State
                  </label>
                  <input
                    type="text"
                    id="province"
                    name="province"
                    value={province}
                    onChange={(e) => setProvince(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                    placeholder="your province/state"
                  />
                </div>
                <div className="py-2">
                  <label
                    htmlFor="countries"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Country: <span className="text-red-600">*</span>
                  </label>
                  <select
                    id="countries"
                    name="country"
                    onChange={(e) => setCountry(e.target.value)}
                    defaultValue={country}
                    className={`bg-gray-50 border ${errors.country ? "border-red-500" : "border-gray-300"
                      } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                    required
                  >
                    <option value="">--Select country--</option>
                    {countriesData.map((countr) => (
                      <option value={countr.code}>{countr.name}</option>
                    ))}
                  </select>
                  {errors.country && (
                    <p className="text-red-500 text-sm mt-1">{errors.country}</p>
                  )}
                </div>
                <div className="py-2">
                  <label
                    htmlFor="tax_id"
                    className="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Tax ID:
                  </label>
                  <input
                    type="text"
                    id="tax_id"
                    name="tax_id"
                    value={tax_id}
                    onChange={(e) => setTaxId(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                    placeholder="Tax ID"
                  />
                </div>

              </div>

              <div className="w-full my-4">
                <h1 className="text-xl font-bold ">Billing Address</h1>
                <div className="py-2">
                  <input
                    type="checkbox"
                    id="sameAsAddress"
                    name="sameAsAddress"
                    checked={sameAsAddress}
                    onChange={(e) => setSameAsAddress(e.target.checked)}
                    className="mr-1.5"
                  />
                  <label htmlFor="sameAsAddress">Same as address</label>
                </div>
                {!sameAsAddress && (
                  <div className="w-full ">
                    <div className="py-2">
                      <label
                        htmlFor="billing_address1"
                        className="block mb-2 text-sm font-medium text-gray-900 "
                      >
                        Address Line 1: <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        id="billing_address1"
                        name="billing_address1"
                        value={billing_address1}
                        onChange={(e) => setBillingAddress1(e.target.value)}
                        className={`bg-gray-50 border ${errors.billing_address1 ? "border-red-500" : "border-gray-300"
                          } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                        placeholder="address Line 1"
                        required
                      />
                      {errors.billing_address1 && (
                        <p className="text-red-500 text-sm mt-1">{errors.billing_address1}</p>
                      )}
                    </div>
                    <div className="py-2">
                      <label
                        htmlFor="billing_address2"
                        className="block mb-2 text-sm font-medium text-gray-900 "
                      >
                        Address Line 2:
                      </label>
                      <input
                        type="text"
                        id="billing_address2"
                        name="billing_address2"
                        value={billing_address2}
                        onChange={(e) => setBillingAddress2(e.target.value)}
                        className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                        placeholder="address2"
                      />
                    </div>
                    <div className="py-2">
                      <label
                        htmlFor="billing_postcode"
                        className="block mb-2 text-sm font-medium text-gray-900 "
                      >
                        Postcode/ZIP code: <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        id="billing_postcode"
                        name="billing_postcode"
                        value={billing_postcode}
                        onChange={(e) => setBillingPostcode(e.target.value)}
                        className={`bg-gray-50 border ${errors.billing_postcode ? "border-red-500" : "border-gray-300"
                          } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                        placeholder="your postcode/zip code"
                        required
                      />
                      {errors.billing_postcode && (
                        <p className="text-red-500 text-sm mt-1">{errors.billing_postcode}</p>
                      )}
                    </div>
                    <div className="py-2">
                      <label
                        htmlFor="billing_city"
                        className="block mb-2 text-sm font-medium text-gray-900 "
                      >
                        City: <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        id="billing_city"
                        name="billing_city"
                        value={billing_city}
                        onChange={(e) => setBillingCity(e.target.value)}
                        className={`bg-gray-50 border ${errors.billing_city ? "border-red-500" : "border-gray-300"
                          } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                        placeholder="your city"
                        required
                      />
                      {errors.billing_city && (
                        <p className="text-red-500 text-sm mt-1">{errors.billing_city}</p>
                      )}
                    </div>
                    <div className="py-2">
                      <label
                        htmlFor="billing_province"
                        className="block mb-2 text-sm font-medium text-gray-900 "
                      >
                        Province/State
                      </label>
                      <input
                        type="text"
                        id="billing_province"
                        name="billing_province"
                        value={billing_province}
                        onChange={(e) => setBillingProvince(e.target.value)}
                        className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                        placeholder="your province/state"
                      />
                    </div>
                    <div className="py-2">
                      <label
                        htmlFor="billing_countries"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Country: <span className="text-red-600">*</span>
                      </label>
                      <select
                        id="billing_countries"
                        name="billing_country"
                        onChange={(e) => setBillingCountry(e.target.value)}
                        defaultValue={billing_country}
                        className={`bg-gray-50 border ${errors.billing_country ? "border-red-500" : "border-gray-300"
                          } text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5`}
                        required
                      >
                        <option value="">--Select country--</option>
                        {countriesData.map((countr) => (
                          <option value={countr.code}>{countr.name}</option>
                        ))}
                      </select>
                      {errors.billing_country && (
                        <p className="text-red-500 text-sm mt-1">{errors.billing_country}</p>
                      )}
                    </div>
                    <div className="py-2">
                      <label
                        htmlFor="billing_tax_id"
                        className="block mb-2 text-sm font-medium text-gray-900 "
                      >
                        Tax ID:
                      </label>
                      <input
                        type="text"
                        id="billing_tax_id"
                        name="billing_tax_id"
                        value={billing_tax_id}
                        onChange={(e) => setBillingTaxId(e.target.value)}
                        className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                        placeholder="Tax ID"
                      />
                    </div>

                  </div>
                )}
              </div>
              <div className="w-full my-4">
                <h1 className="text-xl font-bold ">Privacy</h1>
                <div className="">
                  <div className="items-center">

                    <div className="text-sm my-2">
                      <label htmlFor="sponsors">
                        I agree to share my information with workshop/tutorials organizers{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>

                    <div className={`flex gap-8 bg-gray-50 border ${errors.workshopCheck ? "border-red-500" : "border-gray-300"} px-2.5 py-0.5 mb-4`}>
                      <div className="py-2 flex items-center">
                        <input
                          id="workshop-yes"
                          type="radio"
                          name="workshop"
                          value="Yes"
                          checked={workshopCheck === "Yes"} // Comprueba si la opción "yes" está seleccionada
                          onChange={() => setWorkshopCheck("Yes")} // Maneja el cambio de selección
                          className="w-4 h-4 text-amber-500 bg-gray-100 border-gray-300 focus:ring-amber-500"
                          required
                        />
                        <label
                          htmlFor="sponsors-yes"
                          className="ms-2 text-sm font-medium text-gray-900"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="py-2 flex items-center">
                        <input
                          id="workshop-no"
                          type="radio"
                          name="workshop"
                          value="No"
                          checked={workshopCheck === "No"}
                          onChange={() => setWorkshopCheck("No")}
                          className="w-4 h-4 text-amber-500 bg-gray-100 border-gray-300 rounded focus:ring-amber-500"
                          required
                        />
                        <label
                          htmlFor="sponsors-no"
                          className="ms-2 text-sm font-medium text-gray-900"
                        >
                          No
                        </label>
                      </div>
                    </div>
                    {errors.workshopCheck && (
                      <p className="text-red-500 text-sm mt-1">{errors.workshopCheck}</p>
                    )}
                  </div>
                  <div className="items-center">

                    <div className="text-sm my-2">
                      <label htmlFor="sponsors">
                        I agree to share my information with conference sponsors{" "}
                        <span className="text-red-600">*</span>
                      </label>
                    </div>

                    <div className={`flex gap-8 bg-gray-50 border ${errors.sponsorsCheck ? "border-red-500" : "border-gray-300"} px-2.5 py-0.5 mb-4`}>

                      <div className="py-2 flex items-center">
                        <input
                          id="sponsors-yes"
                          type="radio"
                          name="sponsors"
                          value="Yes"
                          checked={sponsorsCheck === "Yes"} // Comprueba si la opción "yes" está seleccionada
                          onChange={() => setSponsorsCheck("Yes")} // Maneja el cambio de selección
                          className="w-4 h-4 text-amber-500 bg-gray-100 border-gray-300 focus:ring-amber-500"
                          required
                        />
                        <label
                          htmlFor="sponsors-yes"
                          className="ms-2 text-sm font-medium text-gray-900"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="py-2 flex items-center">
                        <input
                          id="sponsors-no"
                          type="radio"
                          name="sponsors"
                          value="No"
                          checked={sponsorsCheck === "No"}
                          onChange={() => setSponsorsCheck("No")}
                          className="w-4 h-4 text-amber-500 bg-gray-100 border-gray-300 rounded focus:ring-amber-500"
                          required
                        />
                        <label
                          htmlFor="sponsors-no"
                          className="ms-2 text-sm font-medium text-gray-900"
                        >
                          No
                        </label>
                      </div>
                    </div>
                    {errors.sponsorsCheck && (
                      <p className="text-red-500 text-sm mt-1">{errors.sponsorsCheck}</p>
                    )}
                  </div>
                  <div className="items-center">
                    <div className="text-sm my-2">
                      <label htmlFor="delete_profile">
                        Please, delete my personal information after the
                        conference ends <span className="text-red-600">*</span>
                      </label>
                    </div>

                    <div className={`flex gap-8 bg-gray-50 border ${errors.deleteProfileCheck ? "border-red-500" : "border-gray-300"} px-2.5 py-0.5 mb-4`}>

                      <div className="py-2 flex items-center">
                        <input
                          id="delete_profile-yes"
                          type="radio"
                          name="delete_profile"
                          value="Yes"
                          checked={deleteProfileCheck === "Yes"} // Comprueba si la opción "yes" está seleccionada
                          onChange={() => setDeleteProfileCheck("Yes")} // Maneja el cambio de selección
                          className="w-4 h-4 text-amber-500 bg-gray-100 border-gray-300 focus:ring-amber-500"
                          required
                        />
                        <label
                          htmlFor="delete_profile-yes"
                          className="ms-2 text-sm font-medium text-gray-900"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="py-2 flex items-center">
                        <input
                          id="delete_profile-no"
                          type="radio"
                          name="delete_profile"
                          value="No"
                          checked={deleteProfileCheck === "No"}
                          onChange={() => setDeleteProfileCheck("No")}
                          className="w-4 h-4 text-amber-500 bg-gray-100 border-gray-300 rounded focus:ring-amber-500"
                          required
                        />
                        <label
                          htmlFor="delete_profile-no"
                          className="ms-2 text-sm font-medium text-gray-900"
                        >
                          No
                        </label>
                      </div>
                    </div>
                    {errors.deleteProfileCheck && (
                      <p className="text-red-500 text-sm mt-1">{errors.deleteProfileCheck}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </WhiteBoxLayout>
    </>
  );
}

export default PersonalData;
